import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Eye, SearchX } from 'lucide-react';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function SwitchPage() {
  return <div className="min-h-screen bg-[#FAF9F7]" data-id="element-437">
      <Navigation data-id="element-438" />

      <main className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 pt-28 sm:pt-36 pb-24 sm:pb-32" data-id="element-439">
        {/* Hero Heading */}
        <h1 className="text-4xl sm:text-5xl md:text-[3.5rem] font-medium text-[#0F0F0F] tracking-tight leading-[1.15] text-center mb-6 max-w-3xl mx-auto" style={{
        fontSize: '40px',
        fontWeight: '700',
        paddingTop: '10px',
        paddingBottom: '10px'
      }} data-id="element-440">
          Switch to Andoe
        </h1>
        <p className="text-xl text-[#5C5C5C] text-center max-w-2xl mx-auto mb-16 leading-relaxed" data-id="element-441">
          The way businesses are discovered is changing.
        </p>

        {/* Intro Section */}
        <section className="mb-16 border-t border-[#E8E6E3] pt-16" data-id="element-442">
          <div className="grid grid-cols-1 md:grid-cols-[1fr_1.2fr] gap-8 md:gap-16" data-id="element-443">
            <h2 className="text-2xl sm:text-[1.75rem] font-medium text-[#0F0F0F] leading-snug tracking-tight" style={{
            fontWeight: '600'
          }} data-id="element-444">
              AI systems now act as an intermediary between businesses and
              customers.
            </h2>
            <div className="space-y-4 text-[15px] text-[#3D3D3D] leading-relaxed" data-id="element-445">
              <p data-id="element-446">
                People increasingly rely on AI to understand products, compare
                options, and make decisions. Instead of clicking through links,
                they ask questions and expect clear, confident answers.
              </p>
              <p data-id="element-447">Andoe is built for this shift.</p>
            </div>
          </div>
        </section>

        {/* What's happening in search - 3 col grid */}
        <section className="mb-16 border-t border-[#E8E6E3] pt-16" data-id="element-448">
          <h2 className="text-2xl sm:text-[1.75rem] font-medium text-[#0F0F0F] leading-snug tracking-tight mb-12" style={{
          fontWeight: '600'
        }} data-id="element-449">
            What's happening in the search industry
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-450">
            {/* Item 1 */}
            <div data-id="element-451">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#FAF9F7] border border-[#E8E6E3] mb-5" data-id="element-452">
                <ArrowUpRight className="w-6 h-6 text-[#1A1A1A]" data-id="element-453" />
              </div>
              <h3 className="text-lg font-medium text-[#0F0F0F] tracking-tight mb-3" data-id="element-454">
                Discovery is moving upstream
              </h3>
              <p className="text-[15px] text-[#5C5C5C] leading-relaxed" data-id="element-455">
                AI answers questions before people visit a website. If your
                business doesn't appear clearly in those responses, it may never
                enter the consideration set.
              </p>
            </div>
            {/* Item 2 */}
            <div data-id="element-456">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#FAF9F7] border border-[#E8E6E3] mb-5" data-id="element-457">
                <Eye className="w-6 h-6 text-[#1A1A1A]" data-id="element-458" />
              </div>
              <h3 className="text-lg font-medium text-[#0F0F0F] tracking-tight mb-3" data-id="element-459">
                Visibility is no longer just traffic
              </h3>
              <p className="text-[15px] text-[#5C5C5C] leading-relaxed" data-id="element-460">
                Ranking and publishing more content aren't enough. What matters
                is how consistently your business is described across prompts,
                tools, and contexts.
              </p>
            </div>
            {/* Item 3 */}
            <div data-id="element-461">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#FAF9F7] border border-[#E8E6E3] mb-5" data-id="element-462">
                <SearchX className="w-6 h-6 text-[#1A1A1A]" data-id="element-463" />
              </div>
              <h3 className="text-lg font-medium text-[#0F0F0F] tracking-tight mb-3" data-id="element-464">
                Existing tools don't show this layer
              </h3>
              <p className="text-[15px] text-[#5C5C5C] leading-relaxed" data-id="element-465">
                SEO tools track keywords and backlinks. Analytics tools track
                visits and conversions. They don't show how AI systems
                understand and describe your business.
              </p>
            </div>
          </div>
        </section>

        {/* More is better principle */}
        <section className="mb-16 border-t border-[#E8E6E3] pt-16" data-id="element-466">
          <div className="grid grid-cols-1 md:grid-cols-[1fr_1.2fr] gap-8 md:gap-16" data-id="element-467">
            <h2 className="text-2xl sm:text-[1.75rem] font-medium text-[#0F0F0F] leading-snug tracking-tight" style={{
            fontWeight: '600'
          }} data-id="element-468">
              Most AI visibility tools follow a "more is better" principal
            </h2>
            <div className="space-y-4 text-[15px] text-[#3D3D3D] leading-relaxed" data-id="element-469">
              <p data-id="element-470">
                The AI visibility space is evolving quickly. Some take a
                human-in-the-loop, agency-style approach. Others extend
                traditional SEO tooling into AI contexts. Some promise full
                automation.
              </p>
              <p data-id="element-471">
                What's missing is a simpler way to see how AI understands a
                business and what actions actually matter, without unnecessary
                layers or jargon.
              </p>
            </div>
          </div>
        </section>

        {/* Built with marketers */}
        <section className="mb-16 border-t border-[#E8E6E3] pt-16" data-id="element-472">
          <div className="grid grid-cols-1 md:grid-cols-[1fr_1.2fr] gap-8 md:gap-16" data-id="element-473">
            <h2 className="text-2xl sm:text-[1.75rem] font-medium text-[#0F0F0F] leading-snug tracking-tight" style={{
            fontWeight: '600'
          }} data-id="element-474">
              Built with product marketers, not around them
            </h2>
            <div className="space-y-4 text-[15px] text-[#3D3D3D] leading-relaxed" data-id="element-475">
              <p data-id="element-476">
                Modern product marketing teams already know their customers.
                They can write, position, launch, and execute using dozens of
                capable tools.
              </p>
              <p data-id="element-477">What they don't have is clarity on where to focus.</p>

              <ul className="space-y-2 py-2 pl-4 border-l-2 border-[#E8E6E3] my-4 text-[#5C5C5C]" data-id="element-478">
                <li data-id="element-479">Which prompts actually shape discovery?</li>
                <li data-id="element-480">Which ones aren't worth optimizing?</li>
                <li data-id="element-481">Where are competitors showing up that you're not?</li>
                <li data-id="element-482">What should you write next, and why?</li>
              </ul>

              <p data-id="element-483">Andoe was built around those questions.</p>
              <p data-id="element-484">
                We worked closely with experienced marketers to understand how
                AI visibility fits into real marketing workflows. Instead of
                introducing new frameworks or vanity metrics, we designed the
                product to support how teams already think about positioning,
                messaging, and competitive context.
              </p>
              <p data-id="element-485">
                There's no new language to learn. Just clear prompt data,
                competitive comparison, and recommendations that explain what to
                act on and why.
              </p>
            </div>
          </div>
        </section>

        {/* Who switches */}
        <section className="mb-16 border-t border-[#E8E6E3] pt-16" data-id="element-486">
          <div className="grid grid-cols-1 md:grid-cols-[1fr_1.2fr] gap-8 md:gap-16" data-id="element-487">
            <h2 className="text-2xl sm:text-[1.75rem] font-medium text-[#0F0F0F] leading-snug tracking-tight" style={{
            fontWeight: '600'
          }} data-id="element-488">
              Who switches to Andoe
            </h2>
            <div className="space-y-4 text-[15px] text-[#3D3D3D] leading-relaxed" data-id="element-489">
              <p data-id="element-490">
                Teams switch to Andoe when they realize monitoring is not the
                same as strategy.
              </p>
              <p data-id="element-491">
                They've used AI visibility tools that surface more data, more
                prompts, more charts, and more metrics. Dashboards expand.
                Exports grow. Pricing increases. But the core question remains
                unanswered.
              </p>
              <p data-id="element-492">
                They spend hours reviewing prompt data in interfaces that
                weren't designed for focused reading or clear prioritization.
                The platform shows what is happening, but not what matters.
              </p>
              <p data-id="element-493">They don't need more surface area. They need direction.</p>
              <p data-id="element-494">
                They want to know which prompts are worth optimizing, which ones
                to ignore, where competitors appear and they don't, and what to
                write next based on actual visibility gaps. They want
                recommendations grounded in context, not another layer of
                reporting.
              </p>

              <p data-id="element-495">They switch when they're ready for clarity over volume.</p>
            </div>
          </div>
        </section>

        {/* How switching works */}
        <section className="mb-16 border-t border-[#E8E6E3] pt-16" data-id="element-496">
          <div className="max-w-3xl mb-16" data-id="element-497">
            <h2 className="text-2xl sm:text-[1.75rem] font-medium text-[#0F0F0F] leading-snug tracking-tight mb-4" style={{
            fontWeight: '600'
          }} data-id="element-498">
              How the switching process works
            </h2>
            <p className="text-lg text-[#5C5C5C] leading-relaxed" data-id="element-499">
              Switching to Andoe is simple.{' '}
              <span className="font-semibold text-[#0F0F0F]" data-id="element-500">
                Pick one of three options.
              </span>
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-501">
            {/* Step 1 */}
            <div data-id="element-502">
              <span className="block text-[3.5rem] font-semibold leading-none text-[#E8E6E3] tracking-tight select-none mb-4" data-id="element-503">
                01
              </span>
              <h3 className="text-lg font-medium text-[#0F0F0F] tracking-tight mb-3" data-id="element-504">
                Guided onboarding
              </h3>
              <p className="text-[15px] text-[#5C5C5C] leading-relaxed mb-4" data-id="element-505">
                <Link to="/contact" className="underline text-[#0F0F0F] hover:text-[#3D3D3D] transition-colors" data-id="element-506">
                  Book a demo
                </Link>{' '}
                and we'll walk through your current setup together.
              </p>
              <p className="text-[15px] text-[#5C5C5C] leading-relaxed" data-id="element-507">
                We'll also offer a 14-day free trial of our Air plan so you can
                evaluate Andoe alongside your existing tools.
              </p>
            </div>
            {/* Step 2 */}
            <div data-id="element-508">
              <span className="block text-[3.5rem] font-semibold leading-none text-[#E8E6E3] tracking-tight select-none mb-4" data-id="element-509">
                02
              </span>
              <h3 className="text-lg font-medium text-[#0F0F0F] tracking-tight mb-3" data-id="element-510">
                Self-serve setup
              </h3>
              <p className="text-[15px] text-[#5C5C5C] leading-relaxed mb-4" data-id="element-511">
                Go through the onboarding yourself in minutes.
              </p>
              <p className="text-[15px] text-[#5C5C5C] leading-relaxed mb-4" data-id="element-512">
                Define what you want to track. Andoe handles the analysis.
              </p>
              <span className="inline-flex items-center px-3 py-1 text-xs font-medium tracking-wide uppercase rounded-full bg-[#E8E6E3] text-[#5C5C5C]" data-id="element-513">
                Coming soon
              </span>
            </div>
            {/* Step 3 */}
            <div data-id="element-514">
              <span className="block text-[3.5rem] font-semibold leading-none text-[#E8E6E3] tracking-tight select-none mb-4" data-id="element-515">
                03
              </span>
              <h3 className="text-lg font-medium text-[#0F0F0F] tracking-tight mb-3" data-id="element-516">
                Direct support
              </h3>
              <p className="text-[15px] text-[#5C5C5C] leading-relaxed mb-4" data-id="element-517">
                We're one email (jason@andoe.work) or one LinkedIn message away.
              </p>
              <p className="text-[15px] text-[#5C5C5C] leading-relaxed" data-id="element-518">
                Whether you want hands-on guidance or a simple self-serve setup,
                the goal is the same.
              </p>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="border-t border-[#E8E6E3] pt-16 text-center" data-id="element-519">
          <h2 className="text-2xl sm:text-[1.75rem] font-medium text-[#0F0F0F] leading-snug tracking-tight mb-6" style={{
          fontWeight: '600'
        }} data-id="element-520">
            Ready to switch?
          </h2>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8" data-id="element-521">
            <Link to="/contact" className="inline-flex items-center px-6 py-3 text-base font-medium rounded-lg bg-[#1A1A1A] text-white hover:bg-[#0F0F0F] transition-colors duration-200" data-id="element-522">
              Book a Demo
            </Link>
          </div>
        </section>
      </main>

      <Footer data-id="element-523" />
    </div>;
}